import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { CAECore } from "@cae/component-library";
import { Button } from "@mui/material";
import { APPLICATION_ID, baseURL } from "Helpers";
import { loginRequest } from 'Helpers/AuthConfig';
import { resource } from "locales/Resource";
import React, { useCallback } from "react";
import App from "./App";

export const Main: React.FC = () => {
  const { instance } = useMsal();

  const handleLoginRedirect = useCallback((): void => {
    // const redirectStartPage = AppRoutePaths.Home;
    instance.loginPopup({ ...loginRequest })
      .catch((error: Error) => {
        if (error instanceof InteractionRequiredAuthError) {
          console.error("Interaction required:", error.message);
        } else {
          console.error("Login redirect error:", error.message);
        }
      });
  }, [instance]);

console.log('test', process.env.REACT_APP_ENV)
console.log('test', process.env.REACT_APP_CLIENT_ID)

  return (
    <CAECore appName="HubsLogbook" homepage={baseURL} resource={resource} appId={APPLICATION_ID}>
      <AuthenticatedTemplate>
        <App />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Button variant="contained" onClick={() => handleLoginRedirect()}>
          Login
        </Button>
      </UnauthenticatedTemplate>
    </CAECore>
  );
};

export default Main;
